import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { motion } from "framer-motion";

const FAQSection = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const faqs = [
    {
      id: "panel1",
      q: "How can I contact you?",
      a: "You can reach me via the contact form or email me directly.",
      offset: "-10px",
      color: "rgba(0, 0, 0, 0.5)",
      boxShadow: "0 0 20px #FFB3BA", // soft red glow
    },
    {
      id: "panel2",
      q: "Do you work on freelance projects?",
      a: "Yes, I’m open to freelance or collaboration opportunities.",
      offset: "10px",
      color: "rgba(0, 0, 0, 0.5)",
      boxShadow: "0 0 20px #FFDFBA", // orange glow
    },
    {
      id: "panel3",
      q: "What technologies do you use?",
      a: "I specialize in backend development with .NET, and build frontends using React for seamless user experiences..",
      offset: "-10px",
      color: "rgba(0, 0, 0, 0.5)",
      boxShadow: "0 0 20px #FFFFBA", // yellow glow
    },
    {
      id: "panel4",
      q: "How do you approach new projects?",
      a: "I focus on clean architecture, scalability, and smooth developer experience — combining modern patterns like CQRS, microservices, and serverless solutions.",
      offset: "10px",
      color: "rgba(0, 0, 0, 0.5)",
      boxShadow: "0 0 20px #BAFFC9", // green glow
    },
    {
      id: "panel5",
      q: "What’s your software design approach?",
      a: "I believe in writing clean, maintainable, and well-tested code with a strong focus on performance, scalability, and developer experience.",
      offset: "-10px",
      color: "rgba(0, 0, 0, 0.5)",
      boxShadow: "0 0 20px #BAE1FF", // blue glow
    },
  ];

  return (
    <Box
      width={{ xs: "auto", lg: "70%", xl: "60%" }}
      marginLeft="auto"
      marginRight="auto"
      mt={4}
    >
      {faqs.map((item, index) => (
        <motion.div
          key={item.id}
          initial={{ opacity: 0, x: item.offset }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: index * 0.15 }}
        >
          <Accordion
            expanded={expanded === item.id}
            onChange={handleChange(item.id)}
            sx={{
              my: 1,
              borderRadius: 3,
              backdropFilter: "blur(15px)",
              background: item.color,
              color: "#fff",
              boxShadow: {
                xs: "none",
                md: expanded === item.id ? item.boxShadow : "0 0 20px #d4af37",
              },
              transition: "all 0.4s ease",
              "&:hover": {
                transform: "scale(1.03)",
                boxShadow: item.boxShadow,
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
            >
              <Typography variant="subtitle1" fontWeight="bold">
                {item.q}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="#fff">
                {item.a}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </motion.div>
      ))}
    </Box>
  );
};

export default FAQSection;
